import * as React from "react";
import TimeSelector from "@8x8/oxygen-time-selector";
import Tooltip from "@8x8/oxygen-tooltip";

import useEditableCell from "@/react/components/table/useEditableCell";
import { cellErrors } from "@/react/components/table/useTableMutations";
import parseValue from "@/react/validation/parseValue";

import {
  oxygenDurationDataFromSeconds,
  oxygenDurationDataToSeconds,
} from "./convertors";
import { TIME_DISPLAY_FORMAT } from "./constants";

const EditableCell = (cell) => {
  const [containerRef, setContainerRef] = React.useState(null);
  const { value, onChange, onBlur } = useEditableCell(cell);
  const errors = cellErrors(cell);
  const parsedSeconds = parseValue(value);

  const index = cell.row?.index;
  const key = React.useMemo(() => `row-${index}-time-selector`, [index]);
  /**
   * NOTE: The onBlur prop on TimeSelector does not get properly executed.
   *  For example, it will get executed for drop-down picks, but not for
   *  direct user input. (SOURCE: glanced at the library code)
   */
  const onContainerBlur = React.useCallback(
    (e) => {
      // We prevent the onBlur call only if the target changes to another
      // element inside the element losing focus.
      // See https://w3c.github.io/uievents/#idl-focuseventinit
      if (!e.currentTarget.contains(e.relatedTarget)) {
        onBlur();
      }
    },
    [onBlur, key]
  );

  return (
    <div id={key} onBlur={onContainerBlur} ref={setContainerRef}>
      <TimeSelector
        size={"small"}
        ref={containerRef}
        isLeftIconVisible
        timeDisplayFormat={TIME_DISPLAY_FORMAT}
        hasError={errors?.length > 0}
        value={oxygenDurationDataFromSeconds(parsedSeconds)}
        onChange={(durationData) => {
          const seconds = oxygenDurationDataToSeconds(durationData);
          onChange(seconds);
        }}
      />
      {errors?.length > 0 && (
        <Tooltip
          title={errors.join(", ")}
          includeWrapper={false}
          triggerRef={containerRef}
        />
      )}
    </div>
  );
};

export default EditableCell;
